.grid {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content 1fr;
  align-items: center;
  gap: 20px;
}
